import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ProjectSheet } from '../ProjectSheet'
import { useProjectInformationSingleSheetData } from '../../hooks/projectInformationData'
import { useProjectSelectOptions } from '../../hooks/projectSelectOptions'
import { useProjectInformationBasicInformationTableDef } from './basic-information-table-def/information'
import { APPLICATION_FUNCTION_EXTERNAL_ID } from '../../..'
import { AllState } from '../../../../../store'
import { loginToProject } from '../../../../../store/project'

type Props = {
  code?: string
  functionLayerDepth: number
}

// プロジェクト情報画面（プロジェクトメニュー）。更新のみ（作成・削除・ログインなし）。
export const ProjectInformation = ({ code }: Props) => {
  const dispatch = useDispatch()
  const sheet = useProjectInformationSingleSheetData(code || '')
  const { entity } = sheet
  const options = useProjectSelectOptions()
  const tableDef = useProjectInformationBasicInformationTableDef(options)
  const selectedProjectUuid = useSelector(
    (state: AllState) => state.project.selected
  )

  // 情報画面の更新は project スコープAPI（/projects/information/delta）で、認可に
  // プロジェクトヘッダが必要。対象プロジェクトへログインして project.selected を
  // 合わせないと保存が 401 になるため、旧 SingleSheet / WbsItem と同様に揃える。
  useEffect(() => {
    if (entity && selectedProjectUuid !== entity.uuid) {
      dispatch(loginToProject(entity.uuid))
    }
  }, [entity, selectedProjectUuid, dispatch])

  // プロジェクト選択が確定するまでは保存を抑止する（早押しによる 401 を防ぐ）。
  if (entity && selectedProjectUuid !== entity.uuid) return <></>

  return (
    <ProjectSheet
      functionExternalId={
        APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_INFORMATION_REFERENCE
      }
      {...sheet}
      tableDef={tableDef}
    />
  )
}
